import React from "react";
import { Card, DotSeparator, EmptyState, TooltipIcon } from "@sscs/ui";
import RenderChildrenWrapper from "../../common/RenderChildrenWrapper";
import styles from "./malware.module.scss";
const MostSevereThreats = ({ detections, threatNameWrapper, }) => {
    const malwareCount = detections.type.length;
    if (!malwareCount) {
        return (React.createElement("div", { className: styles["empty-state"] },
            React.createElement(EmptyState, { subject: "malware" })));
    }
    const top5 = detections.malware.slice(0, 5);
    return (React.createElement("div", null,
        React.createElement("h3", { className: styles.subtitle }, "5 most severe malware threats"), top5 === null || top5 === void 0 ? void 0 :
        top5.map((malware, index) => (React.createElement("div", { key: index, className: styles["malware-list"] },
            React.createElement("span", { className: styles["count"] },
                "\u00D7",
                malware.count.toLocaleString()),
            React.createElement("div", null,
                React.createElement(RenderChildrenWrapper, { wrapper: threatNameWrapper &&
                        ((children) => threatNameWrapper(malware.result, children)) }, malware.result)))))));
};
const CategoryBars = ({ detections, onBarClick, }) => {
    if (!detections.type.length)
        return null;
    const counts = detections.type.map((detection) => detection.total_count);
    const maxCount = Math.max(...counts, 1);
    const totalThreats = counts.reduce((acc, count) => acc + count, 0);
    return (React.createElement("div", { className: styles["category-bars"] },
        React.createElement("h3", { className: styles.subtitle },
            React.createElement("span", null, "By category"),
            React.createElement(DotSeparator, null),
            React.createElement("span", null, "ordered by severity")),
        React.createElement("div", { className: styles["rail-and-bars"] },
            React.createElement("div", { className: styles["severity-rail"], "aria-hidden": "true" },
                React.createElement("span", { className: styles["rail-line"] }),
                React.createElement("svg", { width: "8", height: "6", viewBox: "0 0 8 6", className: styles["rail-arrow"] },
                    React.createElement("path", { d: "M1 1 L4 5 L7 1" }))),
            React.createElement("div", { className: styles["bar-list"] }, detections.type.map(({ threat_type, total_count }) => (React.createElement("button", { key: threat_type, type: "button", className: styles.row, disabled: !onBarClick || threat_type === "Other", onClick: () => onBarClick === null || onBarClick === void 0 ? void 0 : onBarClick(threat_type) },
                React.createElement("span", { className: styles["row-label"] }, threat_type),
                React.createElement("span", { className: styles["bar-track"] },
                    React.createElement("span", { className: styles.bar, style: { width: `${(total_count / maxCount) * 100}%` } })),
                React.createElement("span", { className: styles["row-count"] }, total_count.toLocaleString())))))),
        React.createElement("div", { className: styles.footer },
            totalThreats.toLocaleString(),
            " threats across",
            " ",
            detections.type.length.toLocaleString(),
            " categories")));
};
const MalwarePanel = ({ helperText, children, }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { details: [
                React.createElement(TooltipIcon, { key: "tooltip", size: "xs", title: "Threats found during software package analysis." }),
            ], actions: helperText }, "Malware"),
        React.createElement(Card.Content, null,
            React.createElement("div", { className: styles.content }, children))));
};
export default {
    Panel: MalwarePanel,
    CategoryBars,
    MostSevereThreats,
};
//# sourceMappingURL=Malware.js.map